import { Typography } from '@mui/material';

const NotFound = () => {
    return (
        <>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }} gutterBottom>
                404 Siden finnes ikke 😭
            </Typography>
        </>
    );
};

export default NotFound;